import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  userObjState,
  pagesObjState,
  editModeState,
  addModeState,
  editObjState,
  copiedMarksState,
} from "../recoil-atom"

import { emptyMark } from "../initdata"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
  ListPages,
  PageMarks,
  GroupMarks,
  Mark,
  MarkIcon,
} from "../styled-components-openmark"

const CopiedMarks = () => {
  const [size, setSize] = useRecoilState(sizeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const [pagesObj, setPagesObj] = useRecoilState(pagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [addMode, setAddMode] = useRecoilState(addModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)
  const [copiedMarks, setCopiedMarks] = useRecoilState(copiedMarksState)

  return (
    <>
      <div className="back" />
      <div className="flex">
        
        <div className="marks-window">
          {copiedMarks.map((mark) => (
            <>
              <Mark>
                {mark.thumbnail ? (
                  <MarkIcon thumbnail={mark.thumbnail} />
                ) : (
                  <MarkIcon
                    bgColor={mark.bgColor}
                    color={mark.color}
                  >
                    {mark.title}
                  </MarkIcon>
                )}
                <div>{mark.title}</div>
              </Mark>
            </>
          ))}
        </div>
      </div>

      <style jsx>{`
        .back {
          z-index: 20;
          width: 100vw;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          background-color: #777;
          opacity: 0.6;
        }
        .flex {
          z-index: 20;
          width: 100vw;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          padding-top: 100px;
          display: flex;
          justify-content: center;
          // align-items: center;
        }
        .marks-window {
          width: 300px;
          height: 240px;
          margin-top: 10px;
          border-radius: 10px;
          border: ${copiedMarks.length >= 6 ? "solid 2px red" : "none"};
          padding-top: 20px;
          background-color: ${userObj.colors.b0};
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          justify-items: center;
        }
      `}</style>
    </>
  )
}

export default CopiedMarks
